import React, { lazy, Suspense, useEffect, useState } from "react";
import "./login-modal.scss";
import DefaultModal from "../DefaultModal";
import { useAppSelector } from "../../../store/index.ts";
import LoaderContainer from "../../mui/loader_container/LoaderContainer.jsx";

const LoginModalContent = lazy(() => import("./LoginModalContent"));

export default function LoginModal({ isOpen, closeModal, data: dataLogin, hideCross }) {
  const lockLoginClose = useAppSelector((state) => state.site.lock.loginClose);
  const [forgotPas, setForgotPas] = useState(false);
  const classModal = forgotPas ? "recovery-pas" : "login-modal";

  useEffect(() => {
    setForgotPas(false);
  }, [isOpen]);

  return (
    <DefaultModal
      classModal={classModal}
      isOpen={isOpen}
      closeModal={!lockLoginClose && closeModal}
      hideClose={hideCross || lockLoginClose}>
      <LoaderContainer loader={!isOpen}>
        {isOpen && (
          <Suspense>
            <LoginModalContent
              dataLogin={dataLogin}
              forgotPas={forgotPas}
              closeModal={closeModal}
              setForgotPas={setForgotPas}
            />
          </Suspense>
        )}
      </LoaderContainer>
    </DefaultModal>
  );
}
